import Bullet from 'components/Bullet';
import NotificationNumber from 'components/NotificationNumber';
import { FC, useContext, useMemo } from 'react';
import { NavLink, useLocation, useResolvedPath } from 'react-router-dom';
import styled from 'styled-components';
import Box from './Box';
import { LinkDropDownContext } from './LinkDropDown';

const Container = styled.li`
  display: flex;
  flex-direction: column;
  transition: 0.2s;
  overflow: hidden;
  stroke: var(--gray-700);
  a {
    outline: none !important;
  }
  a:focus > div {
    outline: var(--outline);
  }
  a > div,
  a:focus > div {
    outline-offset: -3px;
    outline-width: 2px;
    transition-property: background-color, color;
  }
`;

type NavigationLinkProps = {
  title: string;
  icon?: React.ReactElement;
  href: string;
  activeLink?: string;
  notification?: boolean;
  notifications?: number;
  isCollapsed?: boolean;
};
const NavigationLink: FC<NavigationLinkProps> = ({
  title,
  icon,
  href,
  activeLink,
  notification,
  notifications,
  isCollapsed,
}) => {
  const { open } = useContext(LinkDropDownContext);
  // Code copied directly from the NavLink definition
  const location = useLocation();
  const path = useResolvedPath(activeLink || href);
  const active = useMemo(() => {
    let locationPathname = location.pathname;
    let toPathname = path.pathname;

    locationPathname = locationPathname.toLowerCase();
    toPathname = toPathname.toLowerCase();
    return (
      locationPathname === toPathname ||
      (locationPathname.startsWith(toPathname) &&
        locationPathname.charAt(toPathname.length) === '/')
    );
  }, [location, path]);
  return (
    <Container>
      <NavLink to={href} tabIndex={open === false ? -1 : 0}>
<Box 
  active={active} 
  style={{ 
        justifyContent: isCollapsed ? 'center' : 'flex-start', // Centre l'icône si réduit
    padding: isCollapsed ? '0' : undefined // Ajuste le padding si besoin
  }}
>
  {icon} 
  
  {/* On n'affiche le titre que si le menu n'est PAS réduit */}
  {!isCollapsed && <span style={{ marginLeft: '1rem' }}>{title}</span>}

  {/* On cache les badges de notification en mode réduit pour rester propre */}
  {!isCollapsed && !!notification && <Bullet style={{ marginLeft: '1rem' }} />}
  {!isCollapsed && !!notifications && (
    <NotificationNumber
      style={{ marginLeft: '1rem' }}
      number={notifications}
    />
  )}
</Box>
      </NavLink>
    </Container>
  );
};

export default NavigationLink;
